// Mémorise les commandes du client sur SON appareil (localStorage), pour qu'il
// puisse retrouver sa page de suivi même après avoir fermé l'onglet.
const KEY = "successnet_my_orders";

export function getMyOrders() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function saveMyOrder({ orderId, slug, storeName }) {
  if (!orderId) return;
  try {
    const list = getMyOrders().filter((o) => o.orderId !== orderId);
    list.unshift({ orderId, slug: slug || "", storeName: storeName || "", savedAt: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 20)));
  } catch (e) {
    // stockage indisponible (mode privé / quota) : on ignore
    if (process.env.NODE_ENV !== "production") console.warn("saveMyOrder: localStorage indisponible", e);
  }
}

export function getMyOrdersForSlug(slug) {
  return getMyOrders().filter((o) => o.slug === slug);
}
